import {FormInstance} from 'antd/es/form';

import {TStateSetter} from 'shared/types/generics';

export enum EDirectoriesCompanyTabs {
    common = 'common',
    aisSignatories = 'aisSignatories',
}

export type TDirectoriesCompanyDto = {
    id: string;
    address: string;
    contactPerson: string;
    contactPhone: string;
    externalCode: string;
    inn: string;
    kpp: string;
    kpp2: string;
    name: string;
    ogrn: string;
    okpo: string;
    okved: string;
    organizationCode: string;
    organizationFnsName: string;
    parentOrgId: string;
    postAddress: string;
    signCertCode: string;
    startDate: string;
    endDate: string;
};

export interface IDirectoriesCompanyFormTabProps {
    form: FormInstance;
    isEntityExists: boolean;
    isDisabled: boolean;
    setDirty: TStateSetter<boolean>;
    resetFormStatus: () => void;
}
